<script>
import { mapActions } from 'vuex';
import request from '@/services/request';

export default {
    data() {
        return {
            errors: {},

            form: {
                id: '',
                name: '',
                rfc: '',
                is_active: true,
            }
        }
    },

    created() {
        Event.$on("event-show-bank-account-group", (group = {}) => {
            this.resetForm();

            if (group && group.id && group.id !== 'without_group') {
                this.form.id = group.id;
                this.form.name = group.name || '';
                this.form.rfc = group.rfc || '';
                this.form.is_active = group.is_active === false || group.is_active === 0 ? false : true;
            }

            this.$modal.show('bankAccountGroupModal');
        });
    },

    beforeDestroy() {
        Event.$off("event-show-bank-account-group");
    },

    methods: {
        resetForm() {
            this.errors = {};

            this.form = {
                id: '',
                name: '',
                rfc: '',
                is_active: true,
            };
        },

        closeModal() {
            this.resetForm();
            this.$modal.hide('bankAccountGroupModal');
        },

        async saveGroup() {
            let form = { ...this.form };
            let endpoint = '/bank_account_groups';

            if (form.id) {
                form._method = 'PUT';
                endpoint = `/bank_account_groups/${form.id}`;
            }

            try {
                let { data } = await request.postMedia(endpoint, form);

                if (data) {
                    this.successNotification(data.message || 'Grupo guardado correctamente.');
                    this.closeModal();
                    Event.$emit('event-load-bank_accounts');
                    Event.$emit('event-load-bank_account_groups');
                }
            } catch (error) {
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="bankAccountGroupModal" :width="'60%'" :height="'auto'">
        <form @submit.prevent="saveGroup">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    {{ form.id ? 'Editar grupo de cuentas' : 'Nuevo grupo de cuentas' }}
                </h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-md-12">
                        <label>Nombre del grupo / titular</label>

                        <input
                            type="text"
                            class="form-control"
                            v-model="form.name"
                            placeholder="Ejemplo: GRUPO M ARQUITECTOS SA DE CV"
                        >

                        <div v-if="errors && errors.name" class="text-danger">
                            {{ errors.name[0] }}
                        </div>
                    </div>

                    <!-- <div class="col-md-12 mt-3">
                        <label>RFC</label>

                        <input
                            type="text"
                            class="form-control"
                            v-model="form.rfc"
                            placeholder="Opcional"
                        >

                        <div v-if="errors && errors.rfc" class="text-danger">
                            {{ errors.rfc[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <div class="custom-control custom-switch">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="groupIsActive"
                                v-model="form.is_active"
                            >

                            <label class="custom-control-label" for="groupIsActive">
                                Grupo activo
                            </label>
                        </div>
                    </div> -->

                    <div class="col-md-12">
                        <hr>

                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>

                        <button type="button" @click="closeModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>